
const getObjectDetail = require('./getObjectDetail').default;

export const REQUEST_GET_TRAT_DETAIL = 'trat/REQUEST_GET_TRAT_DETAIL';
export const RESPONSE_GET_TRAT_DETAIL = 'trat/RESPONSE_GET_TRAT_DETAIL';

export const getTratDetail = (id) => {
    return (dispatch, getState) => {
        getObjectDetail({
            id,
            objectName: 'tratDetail',
            requestFunc: requestGetTratDetail,
            responseFunc: responseGetTratDetail,
            url: '/api/trat/',
            dispatch,
            getState
        });
    }
}

const requestGetTratDetail = (id) => ({
    type: REQUEST_GET_TRAT_DETAIL,
    id
});

const responseGetTratDetail = (res) => ({
    type: RESPONSE_GET_TRAT_DETAIL,
    error: res.error,
    data: res.data
});
